/** Routes that require authentication. Tutorial is NOT here: it is public (shown before auth). */
export const AUTHENTICATED_ROUTES = [
  'index',
  'arena',
  'create',
  'friends',
  'gameResults',
  'worldcup',
  'account-admin',
  'impersonate',
  'admin-impersonate',
  'unimpersonate',
  'privacy-and-data',
  'legal',
  'league-detail',
  'match-details',
  'match',
  'challenge',
  'games',
  'rank-ladder',
  'profile',
  'onboarding',
  // Multi-competition hub + per-competition screens (specs/competitions-hub-client).
  // Missing entries here loop: unknown route → /app/ → index → hub → unknown → …
  'competitions',
  'competition',
]

/**
 * Subset of authenticated routes that anonymous users can browse.
 * 'onboarding' is here so a fresh guest can reach the post-tutorial questionnaire
 * (they enter via an anonymous session — see specs/onboarding-questionnaire).
 */
export const ANONYMOUS_ALLOWED_ROUTES = ['index', 'arena', 'gameResults', 'worldcup', 'create', 'friends', 'games', 'profile', 'onboarding', 'competitions', 'competition']

/** Public routes (redirect to index if already signed in). Landing handles its own redirects. */
export const PUBLIC_ROUTES = ['tutorial', 'landing']

/**
 * OAuth callback and join routes — always allow through regardless of auth state.
 * These need to complete their logic before any redirect.
 */
export const OAUTH_CALLBACK_ROUTES = [
  'oauth-native-callback',
  'oauth-gmail-callback',
  'invite',
  'join',
  'org',
  'wc-invite',
]
